import style from "./style.module.sass";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { useActions } from "../../../../utils/action-helper";
import { analyseSetFilter, analyseSetModalAccordion, analyseSetTopAccordion } from "../../../../actions";
import { Tooltip } from "@material-ui/core";
import config from "../../../../config"
import { SentimentDissatisfied, SentimentSatisfiedAlt, SentimentVeryDissatisfied } from "@material-ui/icons"

export default function Filter() {

    const { t } = useTranslation();
    const { theme: { bgColors, borderColors, colors } } = useTheme()
    const filter = useSelector(state => state.analyseData.filter);
    const resultData = useSelector(state => state.analyseData.result.resultData);
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    
    const isContrast = themeState !== config.THEMES_MODES.LIGHT

    const {
        actionAnalyseSetFilter, actionAnalyseSetTopAccordion,
        actionAnalyseSetModalAccordion
    } = useActions({
        actionAnalyseSetFilter: analyseSetFilter,
        actionAnalyseSetTopAccordion: analyseSetTopAccordion,
        actionAnalyseSetModalAccordion: analyseSetModalAccordion
    })

    function handleSwitchFilter(valueName) {
        // close accordions on filter change
        actionAnalyseSetTopAccordion('');
        actionAnalyseSetModalAccordion('');
        actionAnalyseSetFilter({ ...filter, [valueName]: !filter[valueName] })
    }

    return <div className={style.filterbox}>
        <h6 style={{ marginBottom: "17px", fontSize: "14px", fontWeight: "bolder", color: isContrast ? colors.colorContrast : colors.colorMutedText }}> {t('filter-displayed-parameters')} </h6>
        {/* <br /> */}
        <div className={`${style.aktiv} d-flex justify-content-between align-items-center mb-3`} style={{ marginBottom: "-15px" }}>
            <div style={{ fontSize: "14px", fontWeight: 400, color: isContrast ? colors.colorContrast : colors.colorMutedText }}>
                {t('filter-by-urgency')} :
            </div>
            <div className={`d-flex align-items-center`} >
                {/* <p className={`mr-2`}>{t("Active")}</p> */}
                <Tooltip title={<h6 style={{ fontSize: "15px" }}>
                    {filter.red ? `${t('hide-most-urgent-parameters')}` : `${t('show-most-urgent-parameters')}`}
                </h6>} className='ml-2 mr-auto'>
                    {isContrast ? <SentimentVeryDissatisfied onClick={() => handleSwitchFilter('red')} style={{color: colors.colorIcons, border: filter.red ? `1px solid ${borderColors.borderPrimary200}` : 'none', cursor: 'pointer', fontSize: '30px'}} /> : <div onClick={() => handleSwitchFilter('red')} style={{
                        borderColor: borderColors.borderPrimary200,
                        backgroundColor: filter.red ? bgColors.bgStatusError : bgColors.bgPrimary0
                    }} className={`mr-2 ${style.border}`} tabIndex={config.tabIndexes.red}>
                        <div
                            style={{ backgroundColor: bgColors.bgLightPink }} />
                    </div>}
                </Tooltip>
                <Tooltip title={<h6 style={{ fontSize: "15px" }}>
                    {filter.yellow ?
                        `${t('hide-parameters-with-fewer-issues')}` :
                        `${t('show-parameters-with-fewer-issues')}`
                    }
                </h6>} className='ml-2 mr-auto'>
                    {isContrast ? <SentimentDissatisfied onClick={() => handleSwitchFilter('yellow')} style={{color: colors.colorIcons, border: filter.yellow ? `1px solid ${borderColors.borderPrimary200}` : 'none', cursor: 'pointer', fontSize: '30px'}} /> : <div onClick={() => handleSwitchFilter('yellow')} style={{
                        borderColor: borderColors.borderPrimary200,
                        backgroundColor: filter.yellow ? bgColors.bgProgress60 : bgColors.bgPrimary0
                    }} className={`mr-2 ${style.border}`} tabIndex={config.tabIndexes.yellow}>
                        <div
                            style={{ backgroundColor: bgColors.bgLightYellow }} />
                    </div>}
                </Tooltip>
                <Tooltip title={<h6 style={{ fontSize: "15px" }}>
                    {filter.green ?
                        `${t('hide-parameters-without-issues')}` :
                        `${t('show-parameters-without-issues')}`
                    }
                </h6>} className='ml-2 mr-auto'>
                    {isContrast ? <SentimentSatisfiedAlt onClick={() => handleSwitchFilter('green')} style={{color: colors.colorIcons, border: filter.green ? `1px solid ${borderColors.borderPrimary200}` : 'none', cursor: 'pointer', fontSize: '30px'}} /> : <div onClick={() => handleSwitchFilter('green')} style={{
                        borderColor: borderColors.borderPrimary200,
                        backgroundColor: filter.green ? bgColors.bgProgress100 : bgColors.bgPrimary0
                    }} className={`mr-2 ${style.border}`} tabIndex={config.tabIndexes.green}>
                        <div
                            style={{ backgroundColor: bgColors.bgLightGreen }} />
                    </div>}
                </Tooltip>
                {/* <div onClick={() => handleSwitchFilter('blue')} style={{
                borderColor: borderColors.borderPrimary200,
                backgroundColor: filter.blue ? bgColors.bgStatusInfo : bgColors.bgPrimary0
            }} className={`mr-3 ${style.border}`}>
                <div
                    style={{backgroundColor: !filter.blue ? bgColors.bgStatusInfo : bgColors.bgPrimary0}}/>
            </div> */}
            </div>
        </div>

        <div className={`${style.aktiv} d-flex justify-content-between align-items-center mb-3`} style={{ marginTop: "15px" }}>
            <div style={{ fontSize: "14px", fontWeight: 400, color: isContrast ? colors.colorContrast : colors.colorMutedText }}>
                {t('show-relevant-parameters-for')} :
            </div>
            <div className={style.hixClix} style={{ backgroundColor: bgColors.bgFilter }}  >
                {resultData['formulaHix'] !== undefined ?
                    <Tooltip title={<h6 style={{ fontSize: "15px" }}>{filter.hix ? `${t('clear-HIX-parameters')}` : `${t('show-only-HIX-parameters')}`}</h6>} className='ml-2 mr-auto'>
                        <button onClick={() => handleSwitchFilter('hix')} tabIndex={config.tabIndexes.hix} style={{backgroundColor: filter.hix ? bgColors.bgPrimary500 : bgColors.bgFilter, color: (filter.hix || isContrast) ? colors.colorContrast : colors.colorMutedText, border: (isContrast && filter.hix) ? `1px solid ${borderColors.borderPrimary200}` : 'none'}}>
                            {t("HIX_analyse_filter")}
                        </button>
                    </Tooltip> :
                    <Tooltip title={<h6 style={{ fontSize: "15px" }}>
                        {filter.flesch ? `${t('clear-FLESCH-parameters')}` : `${t('show-only-FLESCH-parameters')}`}
                    </h6>} className='ml-2 mr-auto'>
                        <button onClick={() => handleSwitchFilter('flesch')} tabIndex={config.tabIndexes.flesch} style={{backgroundColor: filter.flesch ? bgColors.bgPrimary500 : bgColors.bgFilter, color: (filter.flesch || isContrast) ? colors.colorContrast : colors.colorMutedText, border: (isContrast && filter.flesch) ? `1px solid ${borderColors.borderPrimary200}` : 'none'}}>
                            {t("FLESCH_analyse_filter")}
                        </button>
                    </Tooltip>
                }
                {resultData['formulaCLIX'] !== undefined && <Tooltip title={<h6 style={{ fontSize: "15px" }}>
                    {filter.clix ? `${t('clear-CLIX-parameters')}` : `${t('show-only-CLIX-parameters')}`}
                </h6>} className='ml-2 mr-auto'>
                    <button onClick={() => handleSwitchFilter('clix')} className={`${filter.clix && style.activeHixClix}`} tabIndex={config.tabIndexes.clix} style={{backgroundColor: filter.clix ? bgColors.bgPrimary500 : bgColors.bgFilter, color: (filter.clix || isContrast) ? colors.colorContrast : colors.colorMutedText, border: (isContrast && filter.clix) ? `1px solid ${borderColors.borderPrimary200}` : 'none'}}>
                        {t("CLIX_analyse_filter")}
                    </button>
                </Tooltip>}
            </div>
        </div>
    </div>
}